import { lazy } from "react";
import Loadable from "components/Loadable";

const MemberRenewPage = Loadable(
  lazy(() => import("features/memberRenew/components/Page"))
);

const routes = {
  path: "member/renew",
  element: <MemberRenewPage />,
};

export default routes;
